import { useCallback, useState } from 'react';

export default function useModal(show = false) {
    const [visible, showModal] = useState(show);
    const toogleModal = useCallback((status) => showModal(d => typeof status === 'boolean' ? status : !d), []);

    return { visible, toogleModal };
}
